import { Colors, Flex } from '@banhala/ui-kit';
import React, { type ReactElement } from 'react';

export const IconOnlyButton: React.FC<{
  children: ReactElement<{ width: number; height: number; fill: string }>;
  testID: string;
  onPress: () => void;
}> = props => {
  return (
    <Flex
      width={40}
      height={40}
      borderRadius={'small'}
      alignItems={'center'}
      justifyContent={'center'}
      borderWidth={1}
      borderColor={'border_primary'}
      onPress={props.onPress}
      testID={props.testID}
    >
      {React.cloneElement(props.children, {
        width: 20,
        height: 20,
        fill: Colors.content_secondary,
      })}
    </Flex>
  );
};
